import styled from "styled-components";

export const Wrapper = styled.div`
    form {
        label{
            font-family: Archivo;
            font-weight: 400;
            font-size: 12px;
            line-height: 127%;
            letter-spacing: 0px;
            color: #808080;
        }
        button {
            border-radius: 4px;
            background: #0b9c07;
            padding: 12px;
            font-weight: 600;
            font-size: 14px;
            width: 100%;
            max-width: 100%;
        }
    }
`
export const AvailableCouponsWrapper = styled.div`
    div {
        &:nth-of-type(2) {
            div {
                color: var(--color-primary);
            }

            background: #AEDEAC4D;
        }
        &:nth-of-type(3) {
            background: #F9F9F9;

            div {
                color: #808080;
            }
        }
        &:nth-of-type(4) {
            background: #FFF7E9;

            div {
                color: #FFA531;
            }
        }
    }
    
    h4 {
        font-weight: 500;
        font-size: 13px;
        line-height: 127%;
        letter-spacing: 0px;
        color: black;
    }
    .custom-divider{
        --tw-space-y-reverse: 0.5;
    }
    .outer {
        border-radius: 8px;
        position: relative;
        width: 100%;
        padding: 12px;

        div {
            color: var(--color-primary);
            line-height: 100%;
            letter-spacing: 0.5px;

            p {
                font-weight: 400;
                font-size: 10px;
            }

            h5 {
                font-weight: 600;
                font-size: 12px;
            }

            span {
                font-weight: 500;
            }
        }

        button {
            font-size: 12px;
            padding: 5px 8px;
        }

        &::before {
            content: '';
            position: absolute;
            width: 8px;
            height: 38%;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            border-radius: 0px 400px 400px 0;
            background-color: #FFFFFF;
        }

        &::after {
            content: '';
            position: absolute;
            width: 8px;
            height: 38%;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            border-radius: 400px 0 0 400px;
            background-color: #FFFFFF;
        }
    }
`